module.exports = __webpack_public_path__ + "static/img/construct3.f15323cc.png";